<template>
  <v-dialog :value="showPermissionsForm" @input="v => v || HIDE_PERMISSIONS_FORM()" max-width="600px" scrollable>
    <v-card>
      <!-- TITLE -->
      <v-card-title class="primary">
        <span class="headline">تعديل الصلاحيات</span>
        <v-spacer />
        <v-btn dark icon @click="assignAllPermissions()" title="تحديد الكل">
          <v-icon>mdi-check-all</v-icon>
        </v-btn>
      </v-card-title>

      <!-- PERMISSION -->
      <v-card-text class="pt-5 pb-2">
        <v-container>
          <div v-for="group in permissionsGroups" :key="group.id" class="mb-8">
            <h3 class="mb-3 primary--text">
              <v-icon class="ml-2">mdi-gavel</v-icon>
              {{ group.label }}
            </h3>
            <v-row class="grey lighten-5 pa-2 pb-1">
              <v-col
                v-for="permission in group.permissions"
                :key="permission.id"
                cols="12"
                md="6"
              >
                <v-checkbox
                  v-model="adminPermissions"
                  :label="permission.label"
                  color="green"
                  class="ma-0 mb-2 pa-0 text-right"
                  :value="permission.id"
                  hide-details
                ></v-checkbox>
              </v-col>
            </v-row>
          </div>
        </v-container>
      </v-card-text>

      <!-- ACTIONS -->
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          elevation="1"
          dark
          @click="assignPermission(recordForm.id, adminPermissions)"
        >حفظ</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>


<script>
import { mapState, mapMutations } from "vuex";

export default {
  name: "record-form",


  data: function () {
    return {
      adminPermissions: []
    };
  },


  created() {
    this.fetchPermissionsGroups();
  },


  computed: {
    ...mapState("admins", [
      'permissionsGroups', 'showPermissionsForm', 'recordForm'
    ])
  },


  watch: {
    recordForm(record) {
      if (!record.permissions) return;

      this.adminPermissions = [];
      record.permissions.forEach((permission) => {
        this.adminPermissions.push(permission.id);
      });
    }
  },


  methods: {
    ...mapMutations("admins", ["HIDE_PERMISSIONS_FORM"]),

    assignAllPermissions() {
      this.permissionsGroups.forEach((groups) => {
        groups.permissions.forEach((permission) => {
          this.adminPermissions.push(permission.id) ;
        });
      });
    },

    fetchPermissionsGroups() {
      this.$store.dispatch('admins/fetchPermissionsGroups')
        .catch((error) => {
          this.$bus.$emit('showSnackbar', {
            text: 'تعذر جلب الصلاحيات',
            color: 'accent'
          });
        });
    },

    assignPermission(recordId, permissions) {
      this.$store.dispatch('admins/assignPermissions', { permissions, recordId })
        .then(() => {
          this.$bus.$emit('showSnackbar', {
            text: 'تم تعديل الصلاحيات بنجاح',
            color: 'success'
          });

          this.$emit('update');
          this.HIDE_PERMISSIONS_FORM();
        })
        .catch((error) => {
          this.$bus.$emit('showSnackbar', {
            text: 'تعذر تعديل الصلاحيات',
            color: 'accent'
          });
        });
    },
  },
};
</script>
